import { TitleSection } from '../../../title-section'
import React from 'react'
import { Tab, Row, Nav, Col } from 'react-bootstrap'

import { FeatureTabContent } from '../../../feature-tab-content'

export const FeatureSection = () => (
  <section id="features" className="features">
    <div className="container">
      <TitleSection title="Features" description="Our Hauler Top Features" />

      <Tab.Container id="hauler-features-tab" defaultActiveKey="real-time-updates">
        <Row>
          <Col lg={3}>
            <Nav variant="tabs" className="flex-column">
              <Nav.Item>
                <Nav.Link eventKey="real-time-updates">Real Time Updates</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="no-data">No DATA plan required</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="back-office">Back-office support</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="support-online">On-Line Support System</Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>

          <Col lg={9} className="mt-4 mt-lg-0">
            <Tab.Content>
              <Tab.Pane eventKey="real-time-updates">
                <FeatureTabContent
                  title="Real Time Updates"
                  subTitle="Update the driver's hauled milk info anywhere + anytime."
                  description="Real time milk tracking, inventory, and truck location. Uploading and downloading of milk pickups with just a click of a button on your mobile."
                  featureImage="/assets/img/hauler-app/mmm-mobile.png"
                />
              </Tab.Pane>
              <Tab.Pane eventKey="no-data">
                <FeatureTabContent
                  title="No DATA plan required!"
                  subTitle="Use the hauler mobile app even no network coverage!"
                  description="Only a plant WiFi or Hot Spot is needed for basic functionality (such as upload or download of data). Upgrading to a DATA PLAN is “seamless”."
                  featureImage="/assets/img/hauler-app/hauler-mobile.png"
                />
              </Tab.Pane>
              <Tab.Pane eventKey="back-office">
                <FeatureTabContent
                  title="Back-office support"
                  description="A web application that can be used by your administrator that has full control and access for tickets, customers, drivers and routes."
                  featureImage="/assets/img/hauler-app/hauler-web-1.png"
                />
              </Tab.Pane>

              <Tab.Pane eventKey="support-online">
                <FeatureTabContent
                  title="On-Line Support System"
                  extraContent={
                    <>
                      <p>Our Zendesk system provides...</p>
                      <ul>
                        <li>
                          <p>Support ticket entry, tracking of status</p>
                        </li>
                        <li>
                          <p>Support ticket history and review</p>
                        </li>
                        <li>
                          <p>A complete knowledge base and videos</p>
                        </li>
                        <li>
                          <p>Remote assistance on desktop and mobile platforms</p>
                        </li>
                      </ul>
                    </>
                  }
                  featureImage="/assets/img/hauler-app/hauler-web-3.png"
                />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  </section>
)
